var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "sidebar" }, [
      _c("aside", { staticClass: "menu" }, [
        _c("p", { staticClass: "menu-label" }, [
          _vm._v(_vm._s(_vm.$t("proprio.menu-label")))
        ]),
        _c(
          "ul",
          { staticClass: "menu-list" },
          _vm._l(_vm.categories, function(category) {
            return _c("ProprietaireSidebarClass", {
              key: category.id,
              attrs: { category: category, current: _vm.currentCategory },
              on: {
                "update:current": function($event) {
                  _vm.currentCategory = $event
                }
              }
            })
          }),
          1
        )
      ])
    ]),
    _c("div", { staticClass: "right" }, [_c("ProprietaireDocuments")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }